<template>
  <div>
    <div class="s4s-page" v-if="modifyItem._mode == 'repay' || modifyItem._mode == 'urge'">
      <div class="shadow-container" >
        <div class="s4s-group">
          <span class="s4s-group-tit">车牌号码</span>
          <span class="s4s-group-txt" >{{modifyItem.car_no || '-'}}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">手机号码</span>
          <span class="s4s-group-txt" >{{modifyItem.mobile || '-'}}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">被处罚人</span>
          <span class="s4s-group-txt">{{modifyItem.fine_name || '-'}}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">违章地点</span>
          <span class="s4s-group-txt" >{{modifyItem.Address || '-'}}</span>
        </div>
        <div class="s4s-group">
          <div class="s4s-group-tit">认罚日期</div>
          <span class="s4s-group-txt">{{modifyItem.btr_time||'-'}}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">罚款金额</span>
          <span class="s4s-group-txt red">￥ {{ (modifyItem.Fine/100).toFixed(2) || '0.00'}}</span>
        </div>
        <div class="s4s-group">
          <span class="s4s-group-tit">滞纳金额
          </span>
          <span class="s4s-group-txt red">￥ {{ (modifyItem.own_late_free/100).toFixed(2)}}
          </span>
        </div>
      </div>
      <div v-if="modifyItem._mode == 'urge'" class="container-attention" style="margin-top:10px;" @click="handleShowUrgeHelp()">
        <img src="https://app.s4s.cn/razio/attention_icon_blue.png" style="width:18px;height:18px;margin-right:5px;" />
        <div class="blue">违章代办加急申请规则</div>
        <img src="https://app.s4s.cn/razio/notice_icon_right_blue.png" style="width:7px;height:12px;margin-left:10px;" mode="aspectFit" />
      </div>
      <div v-if="modifyItem._mode == 'repay'" class="container-attention" style="margin-top:10px;" @click="handleShowRepayHelp()">
        <img src="https://app.s4s.cn/razio/attention_icon_blue.png" style="width:18px;height:18px;margin-right:5px;" mode="aspectFit" />
        <div class="blue">违章代办补缴申请规则</div>
        <img src="https://app.s4s.cn/razio/notice_icon_right_blue.png" style="width:7px;height:12px;margin-left:10px;" mode="aspectFit" />
      </div>
      <div class="shadow-container">
        <div v-if="modifyItem._mode == 'urge'" class="s4s-group">
          <div class="s4s-group-tit">加急金额</div>
          <span class="s4s-group-txt red">¥ {{(urgeFee/100).toFixed(2)}}</span>
        </div>
        <div v-if="modifyItem._mode == 'repay'" class="s4s-group">
          <div class="s4s-group-tit">补缴金额</div>
          <span class="s4s-group-txt red">¥ {{(modifyItem.RePayFee/100).toFixed(2)}}</span>
        </div>
        <div class="s4s-group">
          <div class="s4s-group-tit">完成时间</div>
          <span class="s4s-group-txt">{{modifyItem._mode == 'urge' ? '24小时内完成' : '2小时内完成'}}</span>
        </div>
      </div>
      <div style="height:52px;"></div>
      <div class="s4s-pay" >
        <div class="s4s-pay-container">
          <div class="s4s-pay-btn" >
              <div class="s4s-pay-text">支付金额：<span style="color:#FD2900;font-weight: bold;">￥ {{  ((modifyItem._mode == 'urge' ? urgeFee : modifyItem.RePayFee)/100).toFixed(2)  }}</span></div>
              <div class="s4s-pay-tip">预计{{modifyItem._mode == 'urge' ? '2小时内完成' : '24小时内完成'}}</div>
          </div>
          <div type="default" class="s4s-pay-btn" @click="formSubmit">去下单</div>
        </div>
      </div>
      <div v-if="isRepayHelpShow" class="test" @click.stop="handleShowRepayHelp()">
        <div class="test-title">
          违章代办补缴规则
        </div>
        <div class="shadow-container" style="box-shadow:none;padding:0 15px;padding-bottom:15px;border-top-left-radius:0;border-top-right-radius:0;">
          <div class="help-text">
            1、由于您罚单信息填写有所误差，所以需要您进行费用补缴。
          </div>
          <div class="help-text">
            2、若您尽快完成补缴，否则该订单将取消处理。
          </div>
          <div class="help-text">
            3、订单费用补缴后，会尽快为您服务，请耐心等待结果。
          </div>
          <button class="default-btn" type="default" @click.stop="handleShowRepayHelp()" style="margin-top: 50rpx;">确认</button>
        </div>
      </div>
      <div v-if="isUrgeHelpShow" class="test" @click.stop="handleShowUrgeHelp()">
        <div class="test-title">
          违章代办加急申请规则
        </div>
        <div class="shadow-container" style="box-shadow:none;padding:0 15px;padding-bottom:15px;border-top-left-radius:0;border-top-right-radius:0;">
          <div class="help-text">
            1、加急后两小时内完成对应订单办理。
          </div>
          <div class="help-text">
            2、若订单中违章信息有误，则会影响您的办理进度。
          </div>
          <div class="help-text">
            3、订单加急申请后，会尽快为您服务，请耐心等待结果。
          </div>
          <button class="default-btn" type="default"  @click.stop="handleShowUrgeHelp()" style="margin-top: 50rpx;">确认</button>
        </div>
      </div>
    </div>
    <div v-if="modifyItem._mode == 'reupload'">
      <div class="upload-waring">
        <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/vio_miniapp/ai_form_waring.png" mode="widthFix" style="width:18px;margin-right:5px;" />
        <div>重新上传罚单请保证图片信息清晰</div>
      </div>
      <div class="s4s-page" >
        <div class="shadow-container" >
          <div class="s4s-group group-upload" style="align-items:center;">
            <div class="s4s-group-tit">上传罚单</div>
            <div style="flex:1;display: flex;">
              <img
                :src="ticketUrl||require('../assets/icon/uplaod3.png')"
                style="width:90px;height:70px;"
                mode="scaleToFill"
                @click="chooseImage('ticket')" />
              <canvas id="canvas" style="display: none;"></canvas>
            <input type="file" accept="image/*" @change="uploader"
            ref="file" style="display: none;">
            </div>
          </div>
        </div>
        <button type="default" class="default-btn" @click="gotoUpload()">重新上传</button>
      </div>
    </div>
    <!-- 招行付款form请求 start -->
    <form ref="cmbform" action="https://netpay.cmbchina.com/netpayment/BaseHttp.dll?MB_APPPay" method="post" >
      <input ref="jsonRequestData" id="jsonRequestData" type="hidden" name="jsonRequestData" v-model="jsonRequestData" />
      <input ref="child" type="hidden" name="charset" value='utf-8' />
    </form>
    <!-- 招行付款form请求 end -->
    <!-- 扫码付款 start -->
    <div class="s4s-mask-pay" @click="closePay" v-if="showpay">
      <p>请扫码付款</p>
      <img :src="paysrc" />
    </div>
      <!-- 扫码付款 end -->
      <a ref="newWebpay"></a>

    <Pay v-on:confirm="gotoPay"
    v-on:cancel="showDialog = false"
    v-on:change="changeType"
    :selected="payType"
    :showDialog="showDialog" :alipay="true" :wechat="showWeixinPay" />
  </div>
</template>

<script>
import Pay from '@/components/Pay.vue';
import advertisingShow from './../utils/advertising';

export default {
  name: 'orderModify',
  components: {
    Pay,
  },
  data() {
    return {
      modifyItem: {

      },
      urgeFee: 1000,
      isUrgeHelpShow: false,
      isRepayHelpShow: false,
      ticketUrl: '',
      system: {},
      paysrc: '',
      out_trade_no: '',
      showpay: false,
      timer: null,
      payType: 'alipay',
      showDialog: false,
      showWeixinPay: true,
      jsonRequestData: '',
      advertisingShow: advertisingShow(),
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || this.$store.getters.userInfo;
    },
  },
  mounted() {
    if (this.advertisingShow.channel === 'unionpay' || window.localStorage.getItem('viochannel') === 'unionpay') {
      upsdk.setTitleStyle({
        // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色
        navBackgroundColor:'0x8FFFFFFF',
        appletStyle: 'black', //可选，black-黑色主题，white-白色主题
        backBtnVisible: '1', // 可选，左侧返回按钮是否显示。'0'不显示，'1'显示，不传或空则默认显示
        appletTitleBarVisible: '1',// 可选，标题栏是否显示。'0'不显示，'1'显示，默认显示
      })
      upsdk.setNavigationBarTitle({
        title: '订单修改'
      });
    }
    if (!this.checkLogin()) return;
    const nowChannel = this.advertisingShow.channel;
    const notShowWeixinPay = ['xcarillegal', 'xcarticket']; //   这个数组里的channel 不展示  微信支付
    if (notShowWeixinPay.indexOf(nowChannel) !== -1) {
      this.showWeixinPay = false;
    }
    if (this.advertisingShow.channel === 'cmbapp' || this.advertisingShow.channel === 'cmbchange') {
      this.payType = 'cmbchina2';
      this.access_token = this.$store.getters.token;
      this.channel = window.localStorage.viochannel;
      this.t = (new Date()).getTime();
    }else if (this.advertisingShow.channel === 'abchina' || window.localStorage.getItem('viochannel') === 'abchina') {
      this.payType = 'abchina';
    }
    if (this.advertisingShow.channel === 'unionpay') {
      this.payType = 'unionpay';
    }
    // const p = navigator.platform;
    // this.system.win = p.indexOf('Win') >= 0;
    // this.system.mac = p.indexOf('Mac') >= 0;
    // this.system.x11 = (p === 'X11') || (p.indexOf('Linux') >= 0);
    this.system.win = false;
    this.system.mac = false;
    this.system.x11 = false;


    this.modifyItem = this.$store.getters.orderModify;
    const mode = this.$route.query.mode;
    this.modifyItem._mode = mode;
    console.log(this.modifyItem, mode, '------------mode');
    if (this.modifyItem && mode == 'urge') {
      this.handleGetUrgeFee({
        notice: this.modifyItem.writ_notice_num,
        fine: this.modifyItem.Fine,
        time: this.modifyItem.btr_time,
      });
    } else if (this.modifyItem && mode == 'repay') {

    } else if (this.modifyItem && mode == 'reupload') {

    }
  },
  methods: {
    checkLogin() {
      if (!this.$store.getters.userInfo || !this.$store.getters.token) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/user',
          },
        });
        console.log('checkLogin');
        return false;
      }
      return true;
    },
    handleGetUrgeFee({ notice, fine, time }) {
      const param = {
        notice_num: notice,
        fine: Number(fine),
        vio_time: time,
      };
      this.$request('v3/violation/fee', param).then((xhr, res) => {
        if (res.code === 0 && res.data) {
          this.urgeFee = res.data.Qfee;
        }
      }).catch((e) => {
        console.log(e, 'priceeeeee');
      });
    },
    handleShowUrgeHelp() {
      this.isUrgeHelpShow = !this.isUrgeHelpShow;
      console.log(this.isUrgeHelpShow, 'this.isUrgeHelpShow');
    },
    handleShowRepayHelp() {
      this.isRepayHelpShow = !this.isRepayHelpShow;
      console.log(this.isRepayHelpShow, 'this.isRepayHelpShow');
    },
    gotoUpload() {
      if (!this.ticketUrl) {
        this.$showToast({ title: '请先选择图片' });
      } else {
        const param = {
          order_id: this.modifyItem.id,
          image: this.ticketUrl,
        };
        this.$request('v3/violation/re_upload', param).then((xhr, res) => {
          if (res.code === 0) {
            this.$showToast({ title: '上传成功' });
            this.$router.replace({
              path: '/order',
            });
          } else {
            this.$showToast({ title: res.msg });
          }
        }).catch((e) => {
          console.log(e, 'e');
        });
      }
    },
    // 上传罚单
    chooseImage(type) {
      this.chooseType = type;
      this.$refs.file.value = '';
      this.$refs.file.click();
    },
    // 上传
    uploader() {
      const list = this.$refs.file.files;
      const item = {
        name: list[0].name,
        size: list[0].size,
        file: list[0],
      };
      this.html5Reader(list[0], item);
    },
    html5Reader(file, item) {
      const imgSrc = new Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        imgSrc.src = e.srcElement.result;
        this.$set(item, 'src', e.srcElement.result);
        const self = this;
        imgSrc.onload = function () {//eslint-disable-line
          // 图片原始尺寸
          const originWidth = this.width;
          const originHeight = this.height;
          // 最大尺寸限制
          const maxWidth = 2000;
          const maxHeight = 2000;
          // 目标尺寸
          let targetWidth = originWidth;
          let targetHeight = originHeight;
          // 图片尺寸超过400x400的限制
          if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
              // 更宽，按照宽度限定尺寸
              targetWidth = maxWidth;
              targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
              targetHeight = maxHeight;
              targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
          }
          const canvas = document.getElementById('canvas');
          const context = canvas.getContext('2d');
          // canvas对图片进行缩放
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          // 清除画布
          context.clearRect(0, 0, targetWidth, targetHeight);
          // 图片压缩
          context.drawImage(imgSrc, 0, 0, targetWidth, targetHeight);
          const data = canvas.toDataURL('image/jpeg').split(',')[1];
          // 获取base64图片大小，返回MB数字
          const size = parseInt(data.length - (data.length / 4), 10);
          if (size) {
            const isLt2M = size / 1024 / 1024 < 2;
            if (!isLt2M) {
              self.$showToast({ title: '图片大小需要小于 2MB!' });
              return;
            }
            self.$showToast({ title: '正在上传' });
            self.$requestPost('v3/violation/image/upload', {
              imageString: data,
            }).then((xhr, res) => {
              if (res.code === 0) {
                self.$showToast({ title: '上传成功' });
                if (self.chooseType === 'ticket') {
                  self.ticketUrl = res.data;
                } else if (self.chooseType === 'JSZTravel') {
                  self.JSZTravelUrl = res.data;
                } else if (self.chooseType === 'JSZDrive') {
                  self.JSZDriveUrl = res.data;
                } else if (self.chooseType === 'travelUrl') {
                  self.travelUrl = res.data;
                } else if (self.chooseType === 'driveUrl') {
                  self.driveUrl = res.data;
                }
              } else {
                self.$showToast({ title: res.msg });
              }
            });
          }
        };
      };
      reader.readAsDataURL(file);
    },
    changeType(val) {
      this.payType = val;
    },
    // 立即办理
    formSubmit() {
      if (this.payType === 'cmbchina2') {
        this.gotoPay();
      } else if (this.payType === 'abchina') {
        this.gotoPay();
      } else if (this.payType === 'unionpay') {
        this.gotoPay();
      } else {
        this.showDialog = true;
      }
    },
    gotoPay() {
      this.showDialog = false;
      const self = this;
      const url = this.modifyItem._mode == 'urge' ? 'v3/violation/re_urge' : 'v3/violation/re_pay';
      const param = {
        order_id: this.modifyItem.id,
      };
      if (this.payType === 'wechat_web') {
        param.pay_method = 'wechat_h5';
        param.client_ip = '';
        const city = window.returnCitySN;
        if (city) {
          param.client_ip = city.cip;
        }
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) === 'micromessenger') {
          param.pay_method = 'wechat_app';
        } else {
          param.pay_method = 'wechat_h5';
        }
      }
      if (this.payType === 'abchina') {
        param.pay_method = 'abchina';
        console.log('--------n行支付');
        this.$request(url, param).then((xhr, res) => {
          if (res.code > 0) {
            this.$showToast({ title: res.msg });
            return;
          }
          if (res.data && res.data.qr_code) {
            if(window.navigator.userAgent.indexOf('Bankabc/Portal') != -1) {//1. 判断是否在n行app新容器
              let qr_code = res.data.qr_code.replace('|','*')
              qr_code = qr_code.split('*')
              let tokenId = qr_code[1]
              let webviewURL = qr_code[2]
              AlipayJSBridge.call('startApp',{
                appId: '30603024', // 固定值
                param:{
                  type: "3", //   3： zy内H5页面，
                  tokenId: tokenId,  //商户传过来的tokenId
                  paySystem: "",       //商户传过来的paySystem, 没有则传空字符串
                  payType: "1111",         //商户传过来的payType，没有则传'1111'
                  webviewURL: webviewURL,      //商户传过来的回跳地址
                  startMultApp: 'YES', // 同一个H5容器如果需要多次调起快E付
                  showProgress: 'NO',
                  backBehavior: 'back'
                },
              },function(result){
              });
            }else{
              window.location.href = res.data.qr_code;
            }
          }
        });
        return;
      }
      if (this.payType === 'unionpay') {
        param.pay_method = 'unionpay';

        this.$request(url, param).then((xhr, res) => {
          if (res.code > 0) {
            this.$showToast({ title: res.msg });
            return;
          }
          if (res.data && res.data.tn) {
            upsdk.pay({
              tn: res.data.tn,
              success: () => {
                window.location.href = "https://mys4s.cn/static/vio/index.html#/ticket?channel=unionpay"
              },
              fail: (e) => {

              }
            })
          }
        });
        return;
      }
      if (this.payType === 'cmbchina2' || this.payType === 'cmbchina2') {
        // window.location.href = `https://mys4s.cn/grey/v3/violation/web/order/repay?pay_method=cmbchina2&order_id=${param.order_id
        // }&access_token=${this.access_token}&channel=${this.channel}&t=${this.t}`;
        const cmbform = this.$refs.cmbform;
        param.pay_method = 'cmbchina2';
        this.$request(url, param).then((xhr, res) => {
          if (res.code === 0) {
            document.getElementById('jsonRequestData').value = res.data;
            cmbform.submit();
          }
        });
        return;
      }
      this.$request(url, param).then((xhr, res) => {
        if (res.code === 20022 || (res.code >= 40000 && res.code < 50000)) {
          self.$router.replace({
            path: '/login',
            query: {
              redirect: '/order',
            },
          });
          return;
        }
        if (res.code > 0) {
          self.$showToast({
            icon: 'none',
            title: res.msg,
          });
        }
        if (res.code === 0) {
          if (this.system.win || this.system.mac || this.system.xll) { // 如果是电脑跳转到
            self.paysrc = this.payType === 'wechat_web' ? res.data.CodeImg : res.data.qr_code_img;
            self.out_trade_no = res.data.out_trade_no;
            self.showpay = true;
            self.timer = setInterval(self.getPayStatus, 1000);
            return;
          }
          if (self.payType === 'wechat_web') {
            const ua = navigator.userAgent.toLowerCase();
            const { data } = res;
            if (ua.match(/MicroMessenger/i) === 'micromessenger') {
              if (typeof WeixinJSBridge === 'undefined') {
                this.$showToast({ title: '支付失败,请稍后再试' });
              } else {
                WeixinJSBridge.invoke(//eslint-disable-line
                  'getBrandWCPayRequest', {
                    appId: data.appId, // 公众号名称，由商户传入
                    timeStamp: data.timeStamp || data.timestamp, // 时间戳，自1970年以来的秒数
                    nonceStr: data.nonceStr, // 随机串
                    package: data.package,
                    signType: data.signType, // 微信签名方式：
                    paySign: data.paySign, // 微信签名
                  },
                  (ress) => {
                    if (ress.err_msg === 'get_brand_wcpay_request:ok') {
                      self.$router.replace({
                        path: '/order',
                      });
                    }
                  },
                );
              }
            } else if (res.data && res.data.MwebUrl) {
              self.$refs.newWebpay.href = res.data.MwebUrl;
              self.$refs.newWebpay.click();
            }
          } else {
            window.location.href = res.data.qr_code;
          }
        } else {
          this.showPayEnd = false;
          this.$showToast({ title: res.msg });
        }
      }).catch((e) => {
        this.showPayEnd = false;
        console.log(e, 'priceeeeee');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  body{
    line-height: 1;
  }
  .shadow-container {
    background-color: #fff;
    padding: 0 15px;
    box-shadow: 0 2px 4px 0 #eaeaea;
    font-size: 14px;
    border-radius: 2px;
  }
  .container-attention {
    font-size: 14px;
    color: #989898;
    display: flex;
    align-items: center;
    background-color: #E9EEF3;
    padding: 13px 17px;
  }

  .test {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 999;
    padding: 0 13px;

    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .test-title{
    background-image:url('https://app.s4s.cn/razio/test_bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
    padding: 20px;
    color:#fff;
    text-align:center;
    font-size: 32rpx;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }

  .help-text {
    color: #5B5E6A;
    line-height: 1.4;
    margin-top: 15px;
  }
  .upload-waring {
    background-color: #FFF1DB;
    padding: 15px;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #EF9B17;
  }
  .default-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 5px 15px 0 #eaeaea;
    border-radius: 200px;
    color: #FFFFFF;
    height: auto;
    border: none;
    background-image: linear-gradient(151deg, #537EFF 0%, #105FF8 100%);
    font-size: 18px;
    width: 70%;
    margin: 0 auto;
    margin-top: 50px;
    line-height:47px;
  }
</style>

